import { useState, useEffect } from "react";

import API from "utils/api";
import { anyToHash } from "utils/misc";
import { useUser } from "utils/hooks";

export default function useUserContent(id, type, filters) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(null);
  const [contentType, setContentType] = useState(null);

  useEffect(() => {
    async function fetchUserContent() {
      setLoading(true);

      const { response, data } = await API.fetchUserContent(token, id, type, filters);

      if (response.ok) {
        setResult(data);
        setContentType(type);
      } else {
        setResult(null);
        setContentType(null);
      }

      setLoading(false);
    }

    if (type) {
      fetchUserContent(); 
    }
  }, [id, type, anyToHash(filters)]);

  return {
    loading,
    contentType,
    results: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
